export const LAST_INTERVAL = 'last_interval';
export const LAST_YEAR_INTERVAL = 'last_year_interval';
export const DATE_RANGE = {
    ONE_YEAR: 'one_year',
    ONE_YEAR_END_OF_MONTH: 'one_year_eom',
    THIS_YEAR_END_OF_MONTH: 'this_year_eom',
    THIS_YEAR: 'this_year',
    LAST_YEAR: 'last_year',
    CURRENT_YEARS_EOQ: 'current_years_eoq',
    CURRENT_YEARS_EOM: 'current_years_eom',
}

export const CATCH_ALL_PRODUCT_TECH_NAME = 'Gesamtes Netzwerk';
export const PRODUCT_TECH_NAME_CMS2 = 'CMS2-Internetpräsentation';
export const PRODUCT_TECH_NAME_BASIS3 = 'Basis3-Website';
export const PRODUCT_TECH_NAME_MS2 = 'MANET-Stadt2';
export const PRODUCT_TECH_NAME_MS4 = 'MANET-Stadt4';
export const PRODUCT_TECH_NAME_ABL_LINK_EXTERN = 'ABL-Link-extern';
export const AUTH_COOKIE_NAME = 'manet_ccp_token';
export const AUTH_COOKIE_DURATION = 1; //one day


export const PROVIDERS = {
    google: 'Google',
    manet: 'Manet',
}
// taken from https://echarts.apache.org/en/option.html#color
export const CHART_COLORS = [
    '#5470c6',
    '#91cc75',
    '#fac858',
    '#ee6666',
    '#73c0de',
    '#3ba272',
    '#fc8452',
    '#9a60b4',
    '#ea7ccc'
];

export const BASE_TYPES = {
    events: 'termine',
    offers: 'angebote',
    discover: 'entdecken',
    accommodations: 'unterkunft',
}

export const OSM = {
    attribution: '© <a href="https://osm.org/copyright" target="_blank" rel="noopener noreferrer">OpenStreetMap</a> contributors',
    tileUrl: process.env.VUE_APP_LEAFLET_TILE_URL || console.error("missing env VUE_APP_LEAFLET_TILE_URL"),
}


export const ROUTES = {
    EVENTS: {
        EDIT: 'events.edit'
    },
    OFFERS: {
        EDIT: 'offers.edit',
    },
    DISCOVER: {
        EDIT: 'discover.edit',
    },
    ACCOMMODATIONS: {
        EDIT: 'accommodations.edit',
    },
}

export const CONTRACT_TYPES = {
    quantity: 'quantity',
    quota: 'quota',
    individual: 'individual'
}

export const BASE_TYPE_TRANSLATIONS = {
    events: 'Veranstaltungen',
    offers: 'Angebote',
    discover: 'Entdecken',
    accommodations: 'Unterkünfte'
}
